import {createContext, useContext, useEffect, useState} from 'react'

const UserContext = createContext();

export const UserProvider = ({children}) =>{

    const [dataUser, setDataUser] = useState("");
    const [docu, setDocu] = useState();
    const [ estado, setEstado ] = useState();

    const actions = {
        guardarData : (data) =>{
            setDataUser(prevData => ({
                ...prevData, ...data
            }))
        },
        guardarDocu : (doc) =>{
            setDocu(doc)
        }
    }
    useEffect(()=>{
        if(!dataUser){
            setEstado('/')
        }
    },[dataUser])

    return (
        <UserContext.Provider value={{
            dataUser,
            setDataUser,
            setDocu,
            actions,
            docu
        }}>
            {children}
        </UserContext.Provider>
    )
}

export function useUserContext(){
    return useContext(UserContext);
}